import { Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Chip, IconButton, Menu, MenuItem, InputLabel, Tooltip } from "@mui/material";
import { FaRegSquare } from "react-icons/fa";
import { FaSquareCheck } from "react-icons/fa6";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { ApiRequest, formatCanadianPrice } from "GlobalFunctions";
import { PiHeadsetLight } from "react-icons/pi";
import empty_icon from "assets/img/empty_orders_icon.svg"

export default function BillingHistory() {

    const [payments, setPayments] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingInvoice, setLoadingInvoice] = useState<number | null>(null);

    /*==========================
    STATUS CHIP CONFIGURATION
    ==========================*/
    const getStatusConfig = (status: string) => {
        switch (status) {
            case 'pending':
                return {
                    label: 'Pending Payment',
                    backgroundColor: '#F9E29E',
                    color: '#424242'
                };
            case 'cancelled':
                return {
                    label: 'Payment Failed',
                    backgroundColor: '#F29C9C',
                    color: '#424242'
                };
            default:
                return {
                    label: `${status.charAt(0).toUpperCase() + status.slice(1)}`,
                    backgroundColor: '#D9F9BA',
                    color: '#424242'
                };
        }
    };

    /*==========================
    FETCH BILLING 
    ==========================*/
    const fetchSubscriptionDetails = () => {
        const store_id = localStorage.getItem("store_id");
        setLoading(true);
        ApiRequest({
            method: "GET",
            url: "/stores/getBillingHistory",
            query: { store_id },
            setResponse: (response: any) => {
                setPayments(response.list);
                setLoading(false);
            },
        });
    };

      useEffect(() => {
        fetchSubscriptionDetails();
      }, []);




    const getInvoice = (store_plan_history_id: any) => {
        const store_id = localStorage.getItem("store_id");
        setLoadingInvoice(store_plan_history_id);
        ApiRequest({
            method: "get",
            url: "/utils/generateSubscriptionInvoice",
            query: { 
                store_id,
                store_plan_history_id
            },
            setResponse: (response: any) => {
                setLoadingInvoice(null);
                if (response.status === "success") {
                    // Create a hidden anchor element for file download
                    const link = document.createElement("a");
                    link.href = response.fileUrl;
                    link.setAttribute("download", `billing_invoice_${store_plan_history_id}.pdf`);
                    link.setAttribute("target", "_blank");
                    link.style.display = "none";
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(() => {
                        document.body.removeChild(link);
                    }, 100);
                } else {
                    console.error("Failed to fetch invoice");
                }
            },
        });
    }



    return (
        <div className="account_section">
            <div className="section_header">
                <h2>Billing History</h2>
                <div className="section_actions">

                </div>
            </div>
            <div className="billing_history_table">
                {payments.length > 0 ? (
                    <TableContainer className="table_1">
                        <Table>
                        <TableHead>
                            <TableRow>
                            <TableCell>Order</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Total</TableCell>
                            <TableCell>Payment Status</TableCell>
                            <TableCell>Invoice</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments.map((payment, i) => (
                            <TableRow key={i}>
                                <TableCell># {payment.store_plan_history_id}</TableCell>
                                <TableCell>{new Date(payment.created_at).toLocaleDateString()}</TableCell>
                                <TableCell>${formatCanadianPrice(payment.amount_paid)}</TableCell>
                                <TableCell>
                                    {(() => {
                                        const statusConfig = getStatusConfig(payment.status);
                                        return (
                                            <Chip 
                                                label={`● ${statusConfig.label}`} 
                                                style={{ 
                                                    backgroundColor: statusConfig.backgroundColor,
                                                    color: statusConfig.color,
                                                    borderRadius: "5px",
                                                    height: "30px",
                                                }} 
                                                size="small"
                                            />
                                        );
                                    })()}
                                </TableCell>
                                <TableCell>
                                    <LoadingButton
                                        variant="outlined"
                                        onClick={() => getInvoice(payment.store_plan_history_id)}
                                        className="invoiceButton"
                                        loading={loadingInvoice === payment.store_plan_history_id}
                                    >
                                        Invoice
                                    </LoadingButton>
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <div className="empty_state_message">
                        <img src={empty_icon}/>
                        <h3 className="empty_state_title">No Billing History Yet</h3>
                        <p className="empty_state_text">
                            No Billing Data Yet — Your First Transaction Will Apear Here.
                        </p>
                    </div>
                )}

                <div className="contact_support_cta">
                    <div className="contact_support_text">
                        <h3>Get Support</h3>
                        <p>Looking for help or have a question? Contact our support team.</p>
                    </div>
                    <Button
                        variant="outlined"
                        href="https://pennicart.io/support"
                        target="_blank"
                        startIcon={<PiHeadsetLight />}
                        sx={{ 
                            minHeight: '20px', 
                            padding: '0px 10px', 
                            fontSize: '0.95rem', 
                            borderColor: '#7963ff',
                            height: '32px',
                            '&:hover': {
                                backgroundColor: 'inherit',
                                borderColor: '#7963ff',
                                color: '#7963ff',
                                boxShadow: 'none',
                                transform: 'none'
                            }
                        }}
                    >
                        Visit the Support Center
                    </Button>
                </div>
            </div>
        </div>
    );
}